import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=295157be&scoped=true&lang=pug&"
import script from "./Root.vue?vue&type=script&lang=js&"
export * from "./Root.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295157be",
  null
  
)

export default component.exports